<div class="summary-container">
    <div class="summary-details">
        <div class="summary-subtitle">
            <span>
                {{ 'COMPLAINT|Zgłoszenie z dnia {createdDate}, ostatnio zaktualizowane {modifiedDate}' | translate : {createdDate: (document.created | date: 'shortDate'), modifiedDate: (document.modified | date: 'shortDate')} }}
            </span>
        </div>
        <div class="summary-fields" *ngIf="!preview">
            <div class="summary-fields__container">
                <div class="summary-fields__container__labels">
                    <span class="summary__label" *ngIf="manufacturerStatus && getUserType() !== 'authorizedRetailer'">
                        {{ 'COMPLAINT|Status producenta' | translate }}
                    </span>
                    <span class="summary__label" *ngIf="distributorStatus">
                        {{ 'COMPLAINT|Status dystrybutora' | translate }}
                    </span>
                    <span class="summary__label" *ngIf="authorizedRetailerStatus">
                        {{ 'COMPLAINT|Status APS' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Indywidualny numer reklamacji' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Data planowanej najbliższej wizyty' | translate }}
                    </span>

                    <span class="summary__label" *ngIf="getUserType() === 'manufacturer'">
                        {{ 'COMPLAINT|Numer zamówienia reklamacyjnego' | translate }}
                    </span>
                </div>

                <div class="summary-fields__container__values">
                    <span class="summary__content__header" *ngIf="manufacturerStatus && getUserType() !== 'authorizedRetailer'">
                        <icc-complaint-status [status]="manufacturerStatus"></icc-complaint-status>
                    </span>
                    <span class="summary__content__header" *ngIf="distributorStatus">
                        <icc-complaint-status [status]="distributorStatus"></icc-complaint-status>
                    </span>
                    <span class="summary__content__header" *ngIf="authorizedRetailerStatus">
                        <icc-complaint-status [status]="authorizedRetailerStatus"></icc-complaint-status>
                    </span>

                    <span class="summary__content__header" [class.no-value]="!document.documentName">
                        {{ document.documentName ?? ('INTERFACE|brak' | translate) }}
                    </span>

                    <span class="summary__content__header" [class.no-value]="!findClosestAppointmentDate()">
                        {{ findClosestAppointmentDate() ? (findClosestAppointmentDate() | date: 'shortDate') : ('INTERFACE|nie ustalono' | translate) }}
                    </span>

                    <span class="summary__content__header" [class.no-value]="!document.complaintOrderNumber" *ngIf="getUserType() === 'manufacturer'">
                        {{ document.complaintOrderNumber ?? ('INTERFACE|brak' | translate) }}
                    </span>
                </div>
            </div>

            <div class="summary-fields__container">
                <div class="summary-fields__container__labels">
                    <span class="summary__label">
                        {{ 'COMPLAINT|Rodzaj zgłoszenia' | translate }}
                    </span>

                    <span class="summary__label" *ngIf="+document.documentTypeId === documentTypes.complaint">
                        {{ 'COMPLAINT|Data zakupu' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Podmiot przypisany' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Osoba odpowiedzialna' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Przypisana osoba' | translate }}
                    </span>

                    <span class="summary__label">
                        {{ 'COMPLAINT|Priorytet' | translate }}
                    </span>
                </div>

                <div class="summary-fields__container__values">
                    <span class="summary__content__header">
                        {{ documentTypesDict[document.documentTypeId] | translate }}
                    </span>

                    <span class="summary__content__header" *ngIf="+document.documentTypeId === documentTypes.complaint">
                        <ng-container *ngIf="document.purchaseDate">{{ document.purchaseDate | date: 'shortDate' }}</ng-container>
                        <ng-container *ngIf="!document.purchaseDate && document.documentTypeId === documentTypes.complaint"><i class="errorMessage">{{ 'COMPLAINT|Wprowadź datę zakupu' | translate}}</i></ng-container>
                    </span>

                    <span class="summary__content__header">
                        {{ getAssignedTo() }}
                    </span>

                    <span class="summary__content__header">
                        {{ getResponsibleUser() }}
                    </span>

                    <span class="summary__content__header">
                        {{ getAssignedUser() }}
                    </span>

                    <span class="summary__content__header">
                        {{ getPriority() }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="!preview" id="document-actions">
    <div class="document-actions-bar document-actions-bar__left">
            <button
                iccButton
                appearance="outline"
                (click)="backToList()"
            >
                <icc-icon name="list"></icc-icon>
                {{ navButtonLabel }}
            </button>
    </div>
    <div class="document-actions-bar document-actions-bar__right">
        <button
            *ngIf="hasAccessTo.appealToDistributor"
            iccButton
            appearance="primary"
            (click)="workflowButtonClicked('appeal_to_distributor')"
            [title]="'COMPLAINT|Odwołanie do dystrybutora' | translate"
        >
            {{ 'COMPLAINT|Odwołanie do dystrybutora' | translate }}
        </button>
        <button
            *ngIf="hasAccessTo.appealToManufacturer"
            iccButton
            appearance="primary"
            (click)="workflowButtonClicked('appeal_to_manufacturer')"
            [title]="'COMPLAINT|Odwołanie do producenta' | translate"
        >
            {{ 'COMPLAINT|Odwołanie do producenta' | translate }}
        </button>
        <button
            *ngIf="hasAccessTo.receivedFromManufacturer"
            iccButton
            appearance="primary"
            (click)="workflowButtonClicked('received_from_manufacturer')"
            [title]="'COMPLAINT|Otrzymano od producenta' | translate"
        >
            {{ 'COMPLAINT|Otrzymano od producenta' | translate }}
        </button>
        <button
            *ngIf="hasAccessTo.receivedFromDistributor"
            iccButton
            appearance="primary"
            (click)="workflowButtonClicked('received_from_distributor')"
            [title]="'COMPLAINT|Otrzymano od dystrybutora' | translate"
        >
            {{ 'COMPLAINT|Otrzymano od dystrybutora' | translate }}
        </button>

        <button
            *ngIf="selectedPositions.length > 0 && hasAccessTo.manageComplaint"
            iccButton
            appearance="primary"
            (click)="movePositionsToNewDocument()"
            [title]="'COMPLAINT|Przenieś pozycje do osobnego zgłoszenia' | translate"
        >
            <icc-icon name="copy"></icc-icon>
            {{ 'COMPLAINT|Przenieś wybrane pozycje' | translate }}
        </button>
    </div>
    <div *ngIf="splitNeeded() && hasAccessTo.manageComplaint" class="document-actions--blocked-actions">
        <div class="document-actions--blocked-message">
            <button
                iccButton
                appearance="flat-base"
                (click)="showInfo()"
            >
                <icc-icon name="info"></icc-icon>
                {{ 'COMPLAINT|Dlaczego wymagany jest podział?' | translate }}
            </button>
        </div>
        <button
            iccButton
            appearance="outline"
            (click)="acceptChanges()"
            [title]="'COMPLAINT|Zatwierdź zmiany i przenieś pozycje do osobnych zgłoszeń' | translate"
        >
            <icc-icon name="done"></icc-icon>
            {{ 'COMPLAINT|Wymagany podział - zatwierdź zmiany' | translate }}
        </button>
    </div>
</div>
